import { render, staticRenderFns } from "./NewDRadioEditor.vue?vue&type=template&id=fc70c334&"
import script from "./NewDRadioEditor.vue?vue&type=script&lang=js&"
export * from "./NewDRadioEditor.vue?vue&type=script&lang=js&"
import style0 from "./NewDRadioEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports